import { c as _c } from "react/compiler-runtime";
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { Button } from '@/components/form/baseInputs/Button';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { RichListItem } from '@/components/lists/RichListItem/RichListItem';
import { DialogModal } from '@/components/modals/DialogModal/DialogModal';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { DisplayTable, StyledTableCell } from '@/components/tables/DisplayTable/DisplayTable';
import { StyledTableRow } from '@/components/tables/DisplayTable/StyledTableRow';
import { TableRowSkeleton } from '@/components/tables/TableRowSkeleton/TableRowSkeleton';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getNodes } from '@/utils/graphqlUtils';
import { useAssociatedEntitiesModalQuery } from './graphql/AssociatedEntitiesModal.generated';
interface AssociatedEntitiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  entityIds: string[];
}
export function AssociatedEntitiesModal(t0) {
  const $ = _c(21);
  const {
    isOpen,
    onClose,
    entityIds
  } = t0;
  const {
    householdId
  } = useHouseholdDetailsContext();
  const {
    navigate
  } = useNavigateToRoute();
  let t1;
  let t2;
  if ($[0] !== entityIds) {
    t1 = {
      entityIds
    };
    t2 = isEmpty(entityIds);
    $[0] = entityIds;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    loading
  } = useAssociatedEntitiesModalQuery(t3);
  let t4;
  if ($[6] !== householdId || $[7] !== navigate) {
    t4 = entityId => {
      if (!householdId) {
        throw new Error("No household ID provided");
      }
      navigate(ROUTE_KEYS.HOUSEHOLD_ENTITY_DETAILS, {
        entityId,
        householdId
      });
    };
    $[6] = householdId;
    $[7] = navigate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleRowClick = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: 600
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      headerName: "Entity"
    }, {
      headerName: "Action"
    }];
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data?.entities || $[12] !== handleRowClick || $[13] !== loading) {
    t7 = loading ? Array.from({
      length: 4
    }, _temp) : getNodes(data?.entities).map(t8 => {
      const {
        id,
        subtype
      } = t8;
      return <StyledTableRow key={id} onClick={() => handleRowClick(id)}><StyledTableCell><RichListItem heading={subtype.displayName} /></StyledTableCell><StyledTableCell align="right"><Button variant="transparent" size="xs" aria-label={`View ${subtype.displayName}`} onClick={event => {
            event.stopPropagation();
            handleRowClick(id);
          }} endIcon={ChevronRightIcon} /></StyledTableCell></StyledTableRow>;
    });
    $[11] = data?.entities;
    $[12] = handleRowClick;
    $[13] = loading;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <DisplayTable hideTableHead={true} columns={t6}>{t7}</DisplayTable>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isOpen || $[18] !== onClose || $[19] !== t8) {
    t9 = <DialogModal isOpen={isOpen} onClose={onClose} heading="Asset exists in the following entities" dialogPaperSx={t5}>{t8}</DialogModal>;
    $[17] = isOpen;
    $[18] = onClose;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp(_, index) {
  return <TableRowSkeleton key={index} columns={2} />;
}